import type { ReactElement, ReactNode } from 'react'
import './styles.scss'

interface Props {
  children: ReactNode
}

const SearchBarLayout = ({ children }: Props): ReactElement => {
  return <div className="searchbar__container">{children}</div>
}

export default SearchBarLayout
